import React from 'react';

const ClockIcon = (props) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V11.25H9C8.58579 11.25 8.25 11.5858 8.25 12C8.25 12.4142 8.58579 12.75 9 12.75H12C12.4142 12.75 12.75 12.4142 12.75 12V8C12.75 7.58579 12.4142 7.25 12 7.25Z" fill="currentColor" />
  </svg>
);

export default React.memo(ClockIcon);
